import { useSrStatusText } from '@/src/hooks/store/useSrStatusText';
import styles from './SrStatusText.module.scss';

export const SrStatusText: React.FC = () => {
  const { statusText } = useSrStatusText();

  return (
    <div className={styles.srOnly} aria-live="assertive">
      {statusText}
    </div>
  );
};
